<h5>Find Apps For:</h5>
<div class="row">
    <div class="col-xs-3 col-md-4 text-center" *ngFor="let platformItem of platforms">
      <a routerLink="/appList/{{platformItem.platform}}">
        <img src='{{platformItem.advertisingImage}}'/>
        <button class="btn btn-secondary">{{platformItem.platform}}</button>
      </a>
    </div>
  </div>
